import React from 'react';
import {
  Button,
  Dialog,
  Box,
  Typography,
  Drawer,
  Stack,
  Link,
} from '@mui/material';
import { useModals } from '@mattjennings/react-modal-stack';
import Iconify from '@/components/Iconify';
import useMobile from '@/hooks/useMobile';
import { fCurrency } from '@/utils/formatNumber';
import { useBooking } from '@/store';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';

const RemoveTicketInsuranceDialog = ({
  open,
  onConfirm = () => {},
  onClose = () => {},
  blockClose = false,
}) => {
  const { insuranceTermsViewed } = useAnalyticsEvents();
  const { closeModal } = useModals();
  const { isMobile } = useMobile();
  const {
    resume: { total, currency },
  } = useBooking();

  if (!open) {
    return null;
  }

  const handleClose = () => {
    if (!blockClose) {
      closeModal();
    }
    onClose();
  };

  const handleAcept = () => {
    closeModal();
    onConfirm();
  };

  const body = (
    <>
      <Box
        sx={{
          mr: 2,
          mt: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '48px',
            height: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#FFF6E5',
            borderRadius: '50%',
          }}
          onClick={handleClose}
        >
          <Iconify
            width={32}
            height={32}
            icon={'lucide:triangle-alert'}
            sx={{
              color: '#CC7C02',
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          paddingTop: '16px',
          paddingLeft: '32px',
          paddingRight: '32px',
          paddingBottom: '16px',
        }}
      >
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Typography
            paragraph
            sx={{
              margin: 0,
              padding: 0,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[900]
                  : theme.palette.grey[100],
              fontSize: '20px',
              fontWeight: 600,
              textAlign: 'center',
            }}
            variant="body2"
          >
            ¿Estás seguro que deseas quitar la protección de tu compra?
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            width: '100%',
          }}
        >
          <Typography
            paragraph
            sx={{
              margin: 0,
              padding: 0,
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[700]
                  : theme.palette.grey[300],
              mb: 1,
              textAlign: 'center',
            }}
            variant="body2"
          >
            {`Ten presente que tu compra por ${fCurrency(
              total,
            )} ${currency} quedará desprotegida contra imprevistos.`}
          </Typography>
        </Box>

        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
          }}
        >
          <Box
            sx={{
              color: (theme) => theme.palette.primary.main,
              paddingTop: '8px',
            }}
          >
            <Iconify width={24} height={24} icon={'ph:plus-square'} />
          </Box>
          <Box>
            <Link
              href="https://www.refundable.me/extended/es/"
              variant="caption"
              sx={{
                textDecoration: 'underline',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '15px',
              }}
              target="_blank"
              rel="noopener"
              onClick={() => {
                insuranceTermsViewed();
              }}
            >
              Ver términos y Condiciones
            </Link>
          </Box>
        </Stack>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyItems: 'center',
            mb: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            autoFocus
            fullWidth
            sx={{ mr: 1 }}
          >
            Omitir
          </Button>

          <Button variant="contained" onClick={handleAcept} autoFocus fullWidth>
            Si, quitar protección
          </Button>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      {isMobile ? (
        <Drawer open={open} onClose={handleClose} anchor="bottom">
          {body}
        </Drawer>
      ) : (
        <Dialog open={open} onClose={handleClose} maxWidth="xs">
          {body}
        </Dialog>
      )}
    </>
  );
};

export default RemoveTicketInsuranceDialog;
